<script>
  import { nestedInitial } from '@ducks/nested';
  import { bindAction, store } from '@store';
  import {
    dataSelector,
    typeSelector,
    listSelector,
    titleSelector,
    newsListSelector,
    sectionMenuSelector,
    newsTitleSelector,
    breadcrumbsSelector,
    relatedSelector,
    metaSelector,
    pubdateSelector,
    showGosSelector
  } from '@ducks/nested'
  import {
    backgroundSelector,
    announcementsSelector,
    showAnnouncementsSelector
  } from '@ducks/layout'

  import { showImpairedSelector } from '@ducks/visuallyImpaired';

  import Meta from '@components/Meta'
  import Listings from '@components/Templates/Listings';
  import News from '@components/Templates/News'
  import Page from '@components/Templates/Page';

  export let path, type;
  let data,
      background,
      announcements,
      showAnnouncements,
      list,
      title,
      news,
      sectionMenu,
      breadcrumbs,
      cover,
      nodes,
      editorData,
      related,
      center_x,
      center_y,
      meta,
      listim_id,
      pubdate,
      showImpaired,
      showGos,
      newsTitle;


  $: data = dataSelector($store) || {};
  $: type = typeSelector($store) || '';
  $: listim_id = data && data.listim_id;
  $: background = backgroundSelector($store);
  $: announcements = announcementsSelector($store);
  $: showAnnouncements = showAnnouncementsSelector($store);
  $: title = titleSelector($store) || '';
  $: list = listSelector($store) || [];
  $: news = newsListSelector($store) || [];
  $: sectionMenu = sectionMenuSelector($store) || [];
  $: newsTitle = newsTitleSelector($store) || '';
  $: breadcrumbs = breadcrumbsSelector($store) || []
  $: meta = metaSelector($store) || {}
  $: cover = data.cover || ''
  $: center_x = data.center_x
  $: center_y = data.center_y
  $: editorData = data.editor_data || ''
  $: related = relatedSelector($store) || []
  $: nodes = editorData && JSON.parse(editorData) && JSON.parse(editorData).document && JSON.parse(editorData).document.nodes
  $: pubdate = pubdateSelector($store)
  $: showGos = showGosSelector($store)
  $: showImpaired = showImpairedSelector($store)
</script>

<Meta {...meta} />
<div class="main-wrapper"
  class:dark={!!background}
  class:bigPadding={!!announcements && showAnnouncements}
  class:showImpaired={showImpaired}
>
  {#if type === 'as_exhibitions' || type === 'as_collections'}
    <Listings
      {path}
      {type}
      {background}
      {title}
      {list}
      {sectionMenu}
      {news}
      {newsTitle}
      {showGos}
    />
  {/if}
  {#if type === 'as_news'}
    <News
      {title}
      {list}
      {breadcrumbs}
    />
  {/if}
  {#if type === 'page'}
    <Page
      {path}
      {title}
      {cover}
      {breadcrumbs}
      {nodes}
      {related}
      {center_x}
      {center_y}
      {listim_id}
      {pubdate}
    />
  {/if}
</div>

<style>
  .main-wrapper {

    transition: all 0.3s;
    padding-top: 185px;
    @media (max-width: 1500px) {
      padding-top: 165px;
    }

    @media (max-width: 1199px) {
      padding-top: 117px;
    }

    @media (max-width: 767px) {
      padding-top: 66px;
    }
  }
  .main-wrapper.showImpaired {
    padding-top: calc(185px + 64px);
  }
  .main-wrapper.bigPadding {
    padding-top: 245px;

    @media (max-width: 1500px) {
      padding-top: 225px
    }

    @media (max-width: 1199px) {
      padding-top: 180px
    }

    @media (max-width: 767px) {
      padding-top: 100px;
    }
  }
  .main-wrapper.bigPadding.showImpaired {
    padding-top: calc(245px + 64px);
    @media (max-width: 1500px) {
      padding-top: calc(225px + 64px);
    }

    @media (max-width: 1199px) {
      padding-top: calc(180px + 64px);
    }

    @media (max-width: 767px) {
      padding-top: calc(100px + 64px);
    }
  }
  .main-wrapper.dark {
    background: #2F343D;
  }
</style>
